import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-unauthorized-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: ` <router-outlet></router-outlet> `,
  styles: `
    :host,
    :host ::ng-deep > *:not(router-outlet) {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  `,
})
export class UnauthorizedLayoutComponent {}
